// extracted by mini-css-extract-plugin
export var jobBoardContainer = "FeaturedBoard-module--jobBoardContainer--3hkqD";
export var noResultText = "FeaturedBoard-module--noResultText--1x18q";
export var openPositionCount = "FeaturedBoard-module--openPositionCount--MPuIO";
export var featuredJobs = "FeaturedBoard-module--featuredJobs--TJZ4g";
export var jobBoard = "FeaturedBoard-module--jobBoard--EhT0J";
export var departmentRow = "FeaturedBoard-module--departmentRow--2FFlu";